function addCheckoutEvent() {
    document.querySelectorAll("[name='checkout']").forEach(function(checkoutButton) {
        checkoutButton.addEventListener("click", function(e) {
			console.log()
            var error = false;
            document.querySelectorAll(".quick-cart__cart .form-field, .cart__footer .form-field").forEach(function(field) {
                if (field.classList.contains('form-field--checkbox')) {
                    var checkbox = field.querySelector('input[type=checkbox]');
                    if (checkbox && checkbox.classList.contains("required") && !checkbox.checked) {
                        field.classList.add("error");
                        error = true;
                    } else {
                        field.classList.remove("error");
                    }
                } else {
                    var input = field.querySelector('input, textarea');
                    if (input && input.classList.contains("required") && input.value.trim() === '') {
                        field.classList.add("error");
                        error = true;
                    } else {
                        field.classList.remove("error");
                    }
                }
            });
            if (error) {
                e.preventDefault();
            }
        });
    });
}
document.addEventListener("DOMContentLoaded", function() {
    addCheckoutEvent();
    
    document.querySelectorAll(".quick-cart__cart .form-field input, .cart__footer .form-field input").forEach(function(input) {
        input.addEventListener("change", function() {
			console.log("Change")
            var checked = this.checked;

            // Update cart attribute via Shopify's API
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: `attributes[Terms]=${checked ? 'Yes' : 'no'}`
            });

            // Update all required checkboxes based on CartTerms
            document.querySelectorAll(".quick-cart__cart .form-field, .cart__footer .form-field").forEach(function(field) {
                if (field.classList.contains('form-field--checkbox')) {
                    var checkbox = field.querySelector('input[type=checkbox]');
					console.log(checkbox)                    
					if(checkbox){
						console.log("hallo")
                        checkbox.checked = checked;  // Set the checkbox directly
					}
                    
					console.log(checked)
                }
            });
        });
    });
});
